import React from 'react';
import { View, Text, colors, GridColumn } from '@fairygodboss/ui';
import ResponsivePicture from '../../../../../Elements/ResponsivePicture/ResponsivePicture';
import { useCommunityContent } from '../../CommunityPostContentContext';

export const breakpoints = {
    desktop: {
        width: 669,
        transforms: {
            quality: 'auto',
            crop: 'scale',
            format: 'auto',
        },
    },
    tablet: {
        width: 750,
        transforms: {
            quality: 'auto',
            crop: 'scale',
            format: 'auto',
        },
    },
    smallTablet: {
        width: 665,
        transforms: {
            quality: 'auto',
            crop: 'scale',
            format: 'auto',
        },
    },
    mobile: {
        width: 567,
        transforms: {
            quality: 'auto',
            crop: 'scale',
            format: 'auto',
        },
    },
};

export const ContentImage = ({ communityContext }) => {
    const { isCommunityDiscussionType } = communityContext();
    const {
        contentImage,
        previewTitle,
        previewDescription,
        contentUrl,
        contentTitle,
        handleResize,
        articlePictureRef,
    } = useCommunityContent();
    let alt;
    let src;
    if (contentImage) {
        if (contentTitle.length === 0) {
            alt = contentImage.alt;
        }
        if (contentTitle.length > 125) {
            alt = `${contentTitle.slice(0, 125)}...`;
        } else {
            alt = contentTitle;
        }
        src = contentImage.src;
    } else {
        return <></>;
    }
    const hand = contentUrl ? 'pointer' : 'initial';
    const border = contentUrl ? 'solid 1px #C4CBD8' : 'none';
    return (
        <View display="flex" justifyContent="space-between">
            <GridColumn
                size={{ xs: 12, sm: 12, md: 7.8, lg: 7.6 }}
                css={{ paddingLeft: '0px', paddingRight: '0px' }}
            >
                <a href={contentUrl} target="_new">
                    {contentImage?.src ? (
                        <View
                            css={{
                                marginTop: '20px',
                                borderTop: border,
                                borderBottom: border,
                            }}
                        >
                            <View
                                ref={articlePictureRef}
                                mt={{ _: '24px', sm: '32px', md: '48px' }}
                                overflow="hidden"
                                css={{
                                    '.component-Elements-Picture': {
                                        display: 'block !important',
                                        height: 'auto !important',
                                    },
                                    img: {
                                        width: '100% !important',
                                        height: 'auto !important',
                                        cursor: `${hand} !important`,
                                    },
                                }}
                            >
                                <ResponsivePicture
                                    breakpoints={breakpoints}
                                    cloudinaryID={src}
                                    lazyLoad
                                    alt={alt}
                                    disableHeight
                                    handleOnLoad={handleResize}
                                    {...(isCommunityDiscussionType && {
                                        itemProp: 'image',
                                    })}
                                />
                            </View>
                            <Text
                                as="p"
                                color={colors.neutral[60]}
                                margin="0"
                                textAlign="left"
                                variant="labelSm"
                                pt="16px"
                                css={{
                                    color: '#868686 !important',
                                    textTransform: 'uppercase',
                                    fontSize: '16px',
                                    lineHeight: '24px',
                                    fontWeight: '600',
                                    marginTop: '11px',
                                }}
                            >
                                {previewTitle}
                            </Text>
                            <Text
                                as="p"
                                color="#000000"
                                margin="0"
                                textAlign="left"
                                variant="labelSm"
                                mt="32px"
                                pt="20px"
                                css={{
                                    lineHeight: '24px',
                                    fontSize: '20px',
                                    fontWeight: '600',
                                    color: '#000000!important',
                                    marginTop: '11px',
                                }}
                            >
                                {previewDescription}
                            </Text>
                        </View>
                    ) : (
                        <View
                            mt={{ _: '21px' }}
                            overflow="hidden"
                            css={{
                                borderTop: 'solid 1px #C4CBD8',
                                borderBottom: 'solid 1px #C4CBD8',
                                paddingBottom: '20px',
                                paddingTop: '20px',
                            }}
                        >
                            <Text
                                as="p"
                                color={colors.neutral[60]}
                                margin="0"
                                textAlign="left"
                                variant="labelSm"
                                pt="11px"
                                css={{
                                    color: '#868686 !important',
                                    textTransform: 'uppercase',
                                    cursor: 'default',
                                    fontSize: '16px',
                                    lineHeight: '24px',
                                    fontWeight: '600',
                                    marginTop: '11px',
                                }}
                            >
                                {previewTitle}
                            </Text>
                            <Text
                                as="p"
                                margin="0"
                                textAlign="left"
                                variant="labelSm"
                                pt="11px"
                                css={{
                                    lineHeight: '24px',
                                    fontSize: '20px',
                                    fontWeight: '600',
                                    color: '#000000!important',
                                    marginTop: '11px',
                                }}
                            >
                                {previewDescription}
                            </Text>
                        </View>
                    )}
                </a>
            </GridColumn>
        </View>
    );
};

ContentImage.displayName = 'ContentImage';
